var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.alert.visibility)?_c('div',{staticClass:"form__alert"},[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("warning")]),_c('span',[_vm._v(_vm._s(_vm.alert.message))])],1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }